module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAASpJREFUSEvdlL1KA1EQhb9ZU0QURAjulnkES0sfIS8gaGEdgg/gCnYRTGoRU1jYqWBpYekDWFgIWlhEq23EFMkeWVEhd+P+KAhxypkzH3PPMNdwI1TFX+DVjEpSikesPW/ZcUqXk7BJ9aAjfeXFRr9lvdLgoKttRD1plHH21LRzF/wy4mKuQrsoPIYTG4MYYb9pOy4YuMK4LwoGen8LdicL9lX/3cTw8P7sdCQ7WP25FSU6c6SOx1MHltg0uMwafChqMx4HBssZunErBmIxalmU58hSR0cerBcGA4/AXRZYUDVY+e/Lg2uD2zyPU3UxL2h8frWpv6IfMUtog9JgwO/o1KDx0esciNjD46YsOBZVT+xi1CaDyxK/10/jSftdNU2Z51nKIIkhMYdvjy+Xykcl/s4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Guarantee/file.png
// module id = eAJu
// module chunks = 2